function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { PENDO_API_KEY } from './pendoApiKey';
// This is installation settings provided by Pendo.
// The only modification that was done here is to pass in the apiKey and user object
// as function parameters and declare some variables as 'const' and 'let' to satisfy linter.
const pendoSnippet = (apiKey, user, context) => {
  (function (p, e, n, d) {
    let w, x;
    const o = p[d] = p[d] || {};
    o._q = [];
    const v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
    for (w = 0, x = v.length; w < x; ++w) (function (m) {
      o[m] = o[m] || function () {
        o._q[m === v[0] ? 'unshift' : 'push'](
        // eslint-disable-next-line prefer-rest-params
        [m].concat([].slice.call(arguments, 0)));
      };
    })(v[w]);
    const y = e.createElement(n);
    y.async = !0;
    y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
    const z = e.getElementsByTagName(n)[0];
    z.parentNode.insertBefore(y, z);
  })(window, document, 'script', 'pendo');

  // Call this whenever information about your visitors becomes available
  // Please use Strings, Numbers, or Bool for value types.
  window.pendo.initialize({
    visitor: _objectSpread(_objectSpread({}, context), {}, {
      id: user.analyticsId,
      first_name: user.firstName,
      email: user.email
    })
  });
};
export function initialize(user) {
  let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (process.env.NODE_ENV !== 'test') {
    try {
      pendoSnippet(PENDO_API_KEY, user, context);
    } catch (error) {
      console.error(error);
    }
  }
}
export function updateAttributes(user) {
  let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (process.env.NODE_ENV !== 'test') {
    window.pendo.updateOptions({
      visitor: _objectSpread(_objectSpread({}, context), {}, {
        id: user.analyticsId,
        first_name: user.firstName,
        email: user.email
      })
    });
  }
}
//# sourceMappingURL=pendo.js.map